import React, { useState } from 'react';
import './LanguageSelector.css';
import { useLanguage } from '../../context/LanguageContext';

// Import des drapeaux
import franceFlagImg from '../../assets/france.png';
import ukFlagImg from '../../assets/uk.png';
import spainFlagImg from '../../assets/spain.png';

function LanguageSelector() {
  const { currentLanguage, changeLanguage, languages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);

  // Map des images de drapeaux
  const flagImages = {
    'france.png': franceFlagImg,
    'uk.png': ukFlagImg,
    'spain.png': spainFlagImg
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleLanguageChange = (code) => {
    changeLanguage(code);
    setIsOpen(false);
  };

  // Obtenir le drapeau actuel
  const currentFlag = flagImages[languages[currentLanguage].flag];

  return (
    <div className="language-selector">
      <button className="language-button" onClick={toggleDropdown}>
        <img 
          src={currentFlag} 
          alt={languages[currentLanguage].name} 
          className="flag-icon"
        />
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {Object.keys(languages).map((langCode) => (
            <button 
              key={langCode}
              className={`language-option ${langCode === currentLanguage ? 'active' : ''}`}
              onClick={() => handleLanguageChange(langCode)}
            >
              <img 
                src={flagImages[languages[langCode].flag]} 
                alt={languages[langCode].name}
                className="flag-icon"
              />
              <span>{languages[langCode].name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSelector; 